import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import YourSharedWins from 'components/referrals/2026/YourSharedWins';
import { ComponentProps } from 'react';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const exampleSharedWins: ComponentProps<typeof YourSharedWins>['sharedWins'] = [
  {
    type: 'FRIEND_WIN',
    createdAt: new Date(2026, 0, 1),
    otherPlayerFirstName: 'Alice',
    otherPlayerPrizeTier: 'Diamond',
    promoPrizeRewardName: '£5,000 gift card',
    promoPrizeTier: 'WINWITHFRIENDS_DIAMOND',
    promoPrizeRewardId: 'abcd1234',
    promoPrizeRewardClaimed: false,
  },
  {
    type: 'FRIEND_WIN',
    createdAt: new Date(2026, 0, 2),
    otherPlayerFirstName: 'Luca',
    otherPlayerPrizeTier: 'Platinum',
    promoPrizeRewardName: '£200 gift card',
    promoPrizeTier: 'WINWITHFRIENDS_PLATINUM',
    promoPrizeRewardId: 'def4567',
    promoPrizeRewardClaimed: true,
  },
  {
    type: 'PLAYER_WIN',
    createdAt: new Date(2026, 0, 3),
    otherPlayerFirstNames: ['Alice', 'Luca', 'Tim'],
    prizeTier: 'Bronze',
    otherPlayerPrizeName: 'token',
    otherPlayerPrizeTier: 'WINWITHFRIENDS_TREAT1',
  },
  {
    type: 'FRIEND_WIN',
    createdAt: new Date(2026, 0, 1),
    otherPlayerFirstName: 'Christopher',
    otherPlayerPrizeTier: 'Platinum',
    promoPrizeRewardName: '£200 gift card',
    promoPrizeTier: 'WINWITHFRIENDS_PLATINUM',
    promoPrizeRewardId: 'def4567',
    promoPrizeRewardClaimed: false,
  },
  {
    type: 'PLAYER_WIN',
    createdAt: new Date(2026, 0, 2),
    otherPlayerFirstNames: ['Alice', 'Christopher', 'Tim'],
    prizeTier: 'Bronze',
    otherPlayerPrizeName: 'token',
    otherPlayerPrizeTier: 'WINWITHFRIENDS_TREAT1',
  },
];

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer twoColumn>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <YourSharedWins sharedWins={exampleSharedWins} />
        </AboutUsSiteInnerContainer>
        <div style={{ minHeight: 800, background: 'teal' }} />
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Your Shared Wins',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
